import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';
import { SessionService } from 'src/app/services/session.service';
import { CartService } from 'src/app/services/api/cart.service';
import { SocketioService } from 'src/app/services/socketio.service';

@Component({
	selector: 'app-adminlogin',
	templateUrl: './adminlogin.component.html',
	styleUrls: ['./adminlogin.component.scss']
})
export class AdminloginComponent implements OnInit {

	constructor(
		public _route: ActivatedRoute,
		public router: Router,
		public sessionService: SessionService,
		public cartService: CartService,
		public storage: StorageService,
		public socketioService: SocketioService
	) { }

	ngOnInit() {
		this._route.paramMap.subscribe( param => {
			let user = {
				token: param.get('token'),
				isLogedIn: true
			}
			this.sessionService.signOut('/', false);
			this.storage.setLocal('user', user);

			this.cartService.setLoader(true);
			this.cartService.makeRequest('/rest/entrelable/V1/customers/me', '', 'GET').then(customer => {
				if(customer){
					// this.socketioService.socketConnect().then(() => {
						
						this.cartService.getCartId().then(res => {
							this.cartService.getCart().then(cart => {
								this.sessionService.userData = customer;
								this.sessionService.checkLogin();

								let redirectpath:any = param.get('redirectpath');
								if(redirectpath){
									redirectpath = '/' + redirectpath.split("_").join("/");
									this.router.navigate([redirectpath]);
								} else {
									this.router.navigate(['/my/orders']);
								}
								this.cartService.setLoader(false);
							});
						});
					// });
				} else {
					this.cartService.setLoader(false);
					this.sessionService.signOut();
				}
			});
		});
	}

}
